<template>
  <span
    class="fav-star"
    :class="{ active: isCollect }"
    @click.stop="handleToggle"
    :style="{ pointerEvents: loading ? 'none' : 'auto' }"
    :title="isCollect ? $t('favorites.toggleCancel') : $t('favorites.toggleSuccess')"
  >
    <!-- 未收藏：空心爱心 -->
    <svg v-if="!isCollect" width="20" height="20" viewBox="0 0 24 24" class="heart-icon">
      <path
        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
        fill="none"
        stroke="#999"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
    </svg>
    <!-- 已收藏：实心爱心 -->
    <svg v-else width="20" height="20" viewBox="0 0 24 24" class="heart-icon active-icon">
      <path
        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
        fill="#e0245e"
        stroke="#e0245e"
        stroke-width="1"
        stroke-linejoin="round"
      />
    </svg>
  </span>
</template>

<script>
import { toggleFavorite } from '@/api/favorite'

export default {
  name: 'FavStar',
  props: {
    productId: {
      type: Number,
      required: true
    },
    isCollect: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    async handleToggle() {
      if (this.loading) return
      this.loading = true

      const token = this.$store.state.user.token

      try {
        if (!token) {
          // 未登录：操作 localStorage
          let localFav = []
          try {
            localFav = JSON.parse(localStorage.getItem('localFav') || '[]')
          } catch (e) {
            localFav = []
          }

          const foundIdx = localFav.indexOf(this.productId)

          if (foundIdx > -1) {
            localFav.splice(foundIdx, 1)
            this.$message.success(this.$t('favorites.toggleCancel'))
            this.$emit('update:isCollect', false)
          } else {
            localFav.push(this.productId)
            this.$message.success(this.$t('favorites.localTip'))
            this.$emit('update:isCollect', true)
          }

          localStorage.setItem('localFav', JSON.stringify(localFav))
          return
        }

        // 已登录：请求后端接口
        const res = await toggleFavorite(this.productId)
        const isFav = res.data === true
        this.$emit('update:isCollect', isFav)
        this.$message.success(isFav ? this.$t('favorites.toggleSuccess') : this.$t('favorites.toggleCancel'))
      } catch (err) {
        console.error('Favorite toggle error:', err)
        this.$message.error(this.$t('favorites.toggleFail'))
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.fav-star {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease;
  z-index: 2;
  position: relative;

  &:hover {
    transform: scale(1.15);
  }

  &:active {
    transform: scale(0.95);
  }

  .heart-icon {
    display: block;
    transition: all 0.2s ease;
  }

  &.active {
    .active-icon {
      filter: drop-shadow(0 0 3px rgba(224, 36, 94, 0.4));
    }
  }
}
</style>
